require('admin/common/toll_free_numbers')
require('admin/common/local_numbers')

export class NewCampaignThree extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
      new-campaign-three .radio {
        margin: 20px 10px;
      }
      
      new-campaign-three .campaign-panel {
        margin-left: 22px;
      }
      
      new-campaign-three select.form-control {
        margin-bottom: 0;
      }
      
      new-campaign-three .scrollable_npanxx label {
        font-weight: 500;
      }
      new-campaign-three .campaign-panel {
        height: 360px;
      }
    </style>
    <div class="step-number-header">
      <div class="campaign-step-num"><span>3</span></div>
      <h4>Number Settings</h4>
    </div>
    <div class="step-container hidden">
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-3"></div>
          <section>
            <div class="row">
              <p>Find numbers to assign to your campaign(s).</p>
              <div class="col-md-4 no-gutters form-group">
                <label for="exampleFormControlInput1">Toll Free or Local</label><br/>
                <input type="checkbox" id="campaign_wizard_toll_free" data-key="toll_free" class="wizard_toggle campaign_toll_free" data-on-text="Toll Free" data-off-color="default" data-off-text="Local">
              </div>
              <div class="col-md-8 form-group" id="local-tollfree-numbers">
                <local-numbers class="hidden" numbers-required="1"></local-numbers>
                <toll-free-numbers class="hidden"></local-numbers>
              </div>
            </div>
          </section>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="step-3-finish" data-cy="step-3-finish">Finish</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>
    `;
    $(this.querySelector("#campaign_wizard_toll_free")).bootstrapSwitch('state', true);

    $(this.querySelector("#campaign_wizard_toll_free")).on('switchChange.bootstrapSwitch', function(event, state) {
      if(!state) {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-8');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-12', 'no-gutters');
      } else {
        this.querySelector('#local-tollfree-numbers').classList.remove('col-md-12', 'no-gutters');
        this.querySelector('#local-tollfree-numbers').classList.add('col-md-8');
      }
    }.bind(this));
  }

  revealStep() {
    this.querySelector('.step-container').classList.remove('hidden');
    this.querySelector('.campaign-step-num').classList.add('campaign-step-active');
    this.querySelector('.step-number-header').scrollIntoView({behavior: "smooth"});
  }
}

customElements.define('new-campaign-three', NewCampaignThree)